import { useTranslation } from "react-i18next";
import CommitteeCard from "./CommitteeCard";

import "../styles/CommitteeCardGrid.css";

export default function CommitteeCardGrid({ committeeCardData = [] }) {
  const { t } = useTranslation();

  return (
    <div className="committee-card-grid">
      {committeeCardData.map((committee) => (
        <CommitteeCard
          key={committee.title}
          title={t(committee.title)}
          text={committee.text ? t(committee.text) : undefined}
          members={committee.members}
        />
      ))}
    </div>
  );
}
